module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_office-6fb6cc1fbe019759b2e47375cf4e2bec.svg";